// 侧拉式弹窗
import React, { memo, useEffect, useRef } from 'react';
import { WithErrorHandler } from '../WithErrorHandler';
import smartScroll from '../../utils/smartScroll';
export var SidePullPop = function (_a) {
    var show = _a.show, popId = _a.popId, title = _a.title, scrollId = _a.scrollId, closeFun = _a.closeFun, children = _a.children;
    var smartScrollRef = useRef({});
    useEffect(function () {
        // console.log('slide pop', children)
        if (!scrollId) {
            return;
        }
        smartScrollRef.current = new smartScroll("#" + popId, scrollId);
        if (show) {
            smartScrollRef.current.preventScroll();
        }
        else {
            smartScrollRef.current.allowScroll();
        }
    }, [show, scrollId]);
    return (React.createElement("div", { className: "newcar_ui_sidePullPopWrap " + (show ? 'newcar_ui_moveLeft' : ''), id: popId },
        React.createElement("div", { className: 'newcar_ui_closePop', onClick: closeFun },
            React.createElement("span", null)),
        React.createElement("div", { className: 'newcar_ui_sidePullPopCon' },
            React.createElement("h4", { className: 'newcar_ui_sidePullPopTitle', hidden: !title },
                title,
                React.createElement("a", { className: 'newcar_ui_closeBtn', onClick: closeFun })),
            children)));
};
SidePullPop.defaultProps = {
    popId: '',
    title: '',
    show: false,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
};
export default WithErrorHandler(memo(SidePullPop));
